// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZyN4m{min-height:0;max-height:100%}.iAtDI{min-height:0;max-height:100%}.JYCLC{padding-block-end:16px}.iAtDI .ZyN4m{flex:1;min-height:0}.sdK90{position:relative;width:100%;max-height:100%;overflow:auto}.fKFQm{min-width:fit-content;width:100%;box-sizing:border-box}.H3lqp{border:1px solid #d4d4e0;border-radius:8px}.H3lqp .C94qd{border-radius:8px 8px 0 0}.BENQo{box-sizing:border-box;border:1px solid #d4d4e0;border-radius:8px;padding:8px;background:#fff}.c_gsf.c_gsf{background:transparent;border:none;box-shadow:none;padding:0 8px;margin-bottom:0}.BENQo>*>*{margin-bottom:0}.Q4i9Q{height:16px;background:#fff}.mScpX{height:52px}.H3lqp .WZdpn:last-child{border-radius:0 0 8px 8px}.H3lqp .C94qd .k1OAb{border-top-left-radius:8px}.H3lqp .C94qd .vu5r2{border-top-right-radius:8px}.H3lqp .WZdpn:last-child .tGonv{border-radius:0 0 8px 8px}.H3lqp .WZdpn:last-child .k1OAb{border-bottom-left-radius:8px}.H3lqp .WZdpn:last-child .vu5r2{border-bottom-right-radius:8px}.C94qd .k1OAb{background:#eaeaef}.tGonv.nbEsq .k1OAb{background:#f3f5ff}.C94qd{position:sticky;top:0;z-index:10;display:flex;align-items:stretch;height:32px;box-sizing:border-box;border-radius:4px;background:#eaeaef;margin-bottom:8px}.H3lqp .C94qd{margin-bottom:0}.k1OAb{position:sticky;left:0;z-index:7;flex-shrink:0;min-width:0;overflow:hidden;align-self:stretch;height:100%;display:flex;align-items:center;gap:2px;padding-left:8px;box-sizing:border-box;background:#fff}.Y1x_W.Y1x_W{align-items:stretch}.WS4Hq.WS4Hq{position:sticky;z-index:4}.Tsdp_{position:relative;display:flex;align-items:center;gap:0;flex-shrink:0;flex-grow:0;min-width:0;height:100%;padding:0 12px;box-sizing:border-box;user-select:none}.Tsdp_.qdWTs{position:sticky;z-index:4;align-self:stretch;height:100%;background:#eaeaef}.Tsdp_:hover,.Tsdp_.qdWTs:hover{background:#d4d4e0}.Tsdp_.RObu8{overflow:visible}.Tsdp_.RObu8 .dt-adornments,.Tsdp_.RObu8 .dt-cell-slot{overflow:visible}.Tsdp_.AZkr4{height:auto;padding-top:8px;padding-bottom:8px;white-space:normal}.Tsdp_.ve9Sg{box-shadow:inset -1px 0 0 #eaeaef,4px 0 8px rgba(40,40,99,.06)}.Tsdp_.x2Uwf{cursor:grab}.Tsdp_.uUGeq{box-shadow:inset 2px 0 0 #6942f8}.Tsdp_.iWRN7{box-shadow:inset -2px 0 0 #6942f8}.v_hfq{flex:1;display:flex;align-items:center;gap:8px;min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.v_hfq.OVbJM{justify-content:flex-end}.v_hfq.X9Mcr{justify-content:center}.v_hfq.bUOyN{cursor:pointer}.P3yK0{position:absolute;top:0;bottom:0;right:0;width:8px;cursor:col-resize}.ZIoGB{flex:1 1 0;min-width:0}.vu5r2.aIxcX{box-shadow:inset 1px 0 0 #eaeaef,-4px 0 8px rgba(40,40,99,.06)}.vu5r2{position:sticky;right:0;z-index:6;overflow:visible;width:44px;flex-shrink:0;min-width:0;align-self:stretch;height:100%;display:flex;align-items:center;justify-content:flex-end;padding:0 12px;box-sizing:border-box;background:#fff}.C94qd .vu5r2.aIxcX{box-shadow:inset 1px 0 0 #eaeaef,-4px 0 8px rgba(40,40,99,.06)}.C94qd .vu5r2{background:#eaeaef}.tGonv.nbEsq .vu5r2,.tGonv.nbEsq .TapIu.qdWTs{background:#f3f5ff}.tGonv:hover .TapIu.qdWTs,.tGonv:hover .k1OAb,.tGonv:hover .vu5r2{background:#fcfcfd}.slDBk .tGonv:hover,.slDBk .tGonv:hover .TapIu.qdWTs,.slDBk .tGonv:hover .k1OAb,.slDBk .tGonv:hover .vu5r2{background:inherit}.slDBk .C94qd,.slDBk .tGonv{padding:0 12px}.h88ue{overflow:hidden}.C94qd._sStQ{box-shadow:0 1px 0 0 #eaeaef,0px 4px 12px rgba(40,40,99,.06)}.h88ue .C94qd{box-shadow:none}.h88ue .fKFQm,.h88ue .C94qd,.h88ue .tGonv,.h88ue .WZdpn{min-width:0;width:100%}.slDBk .Tsdp_:hover,.slDBk .Tsdp_.qdWTs:hover{background:#eaeaef}.slDBk .tOVmA .Tsdp_:hover,.slDBk .tOVmA .Tsdp_.qdWTs:hover{background:#fff}.slDBk .tGonv.MIc0p:hover{background:#f3f5ff}.WZdpn{box-sizing:border-box;background:#fff}.WZdpn.me_pp{border-radius:8px;margin-bottom:8px}.WZdpn.Hd2k4{border-bottom:1px solid #f0f0f6}.WZdpn.Hd2k4:last-child{border-bottom:none}.WZdpn.L8Jdd{background:#f3f5ff}.tGonv{display:flex;align-items:center;box-sizing:border-box;background:inherit;transition:background .15s}.tGonv.MIc0p{cursor:pointer}.tGonv.nbEsq{background:#f3f5ff}.tGonv:hover{background:#fcfcfd}.TapIu{display:flex;align-items:center;align-self:stretch;flex-shrink:0;flex-grow:0;min-width:0;padding:0 12px;box-sizing:border-box;overflow:hidden}.TapIu.qdWTs{position:sticky;z-index:2;background:#fff}.TapIu.RObu8{overflow:visible}.TapIu.RObu8 .dt-adornments,.TapIu.RObu8 .dt-cell-slot{overflow:visible}.TapIu.AZkr4{height:auto;padding-top:8px;padding-bottom:8px;white-space:normal}.TapIu.ve9Sg{box-shadow:inset -1px 0 0 #eaeaef,4px 0 8px rgba(40,40,99,.06)}.TapIu.X9Mcr{justify-content:center}.TapIu.OVbJM{justify-content:flex-end}.Dxnn_ .dt-reveal{display:none}.tGonv:hover .Dxnn_ .dt-reveal,.Dxnn_:focus-within .dt-reveal{display:flex}.tGonv:hover .Dxnn_ .dt-actions-pill,.Dxnn_:focus-within .dt-actions-pill{border-color:#d4d4e0;background:#fff;box-shadow:0 2px 8px rgba(40,40,99,.12)}.v2RHh{padding:8px 12px 16px;background:inherit}.YwkxN{flex:none;min-width:16px}.hkRf3{fill:#a9a9c1}.hkRf3.A8Ozh{fill:#6942f8}.Wsapx{display:flex;align-items:center;box-sizing:border-box;padding:0 12px;background:#fff;border-radius:8px;margin-bottom:4px}.nvD6D{flex:none;color:#bfbfd0;opacity:0;transition:opacity .15s}.zefcp{flex:none;margin-left:6px;margin-right:-6px;max-width:0;min-width:0;padding:0;overflow:hidden;color:var(--color-text-secondary, #9e9e9e);border-radius:8px;opacity:0;transition:opacity .2s ease,max-width .2s ease}.zefcp:hover{color:#282863;background:#f4f4f7}.Tsdp_:hover .zefcp{max-width:24px;overflow:visible;opacity:1}.foFMV{display:grid;align-items:stretch;flex:none}.qVppG{position:sticky;left:0;display:flex;align-items:center;justify-content:center;width:100%;padding:32px 12px;box-sizing:border-box}.i9g7V{display:inline-flex}.Wk4jx{background:#fff;border:1px solid #d4d4e0;border-radius:50%;color:#696992}.Wk4jx:hover{color:#282863}.tOVmA{margin-bottom:0;background:#fff;border-bottom:1px solid #d4d4e0;border-radius:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple100": `#dad0fe`,
	"purple300": `#c3b3fc`,
	"purple400": `#b4a1fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"sh10": `0px 4px 12px rgba(40,40,99,.06)`,
	"sh20": `0px 4px 16px rgba(40,40,99,.08)`,
	"sh40": `0px 4px 24px rgba(40,40,99,.12)`,
	"sh60": `0px 4px 14px rgba(40,40,99,.24)`,
	"surface": `ZyN4m`,
	"tableChrome": `iAtDI`,
	"pageControls": `JYCLC`,
	"scroller": `sdK90`,
	"table": `fKFQm`,
	"unifiedTable": `H3lqp`,
	"header": `C94qd`,
	"mobileSummaryFrame": `BENQo`,
	"mobileSummary": `c_gsf`,
	"summarySpacer": `Q4i9Q`,
	"summaryRow": `mScpX`,
	"rowCard": `WZdpn`,
	"checkboxGutter": `k1OAb`,
	"actionsGutter": `vu5r2`,
	"row": `tGonv`,
	"selected": `nbEsq`,
	"headerItem": `Y1x_W`,
	"frozenHeaderItem": `WS4Hq`,
	"headerCell": `Tsdp_`,
	"frozen": `qdWTs`,
	"editableCell": `RObu8`,
	"multilineCell": `AZkr4`,
	"scrolledFrozenEdge": `ve9Sg`,
	"draggable": `x2Uwf`,
	"dropBefore": `uUGeq`,
	"dropAfter": `iWRN7`,
	"headerLabel": `v_hfq`,
	"alignEnd": `OVbJM`,
	"alignCenter": `X9Mcr`,
	"sortable": `bUOyN`,
	"resizeHandle": `P3yK0`,
	"trailingGutter": `ZIoGB`,
	"scrolledEndEdge": `aIxcX`,
	"rowCell": `TapIu`,
	"staticTable": `slDBk`,
	"fixedWidth": `h88ue`,
	"scrolledTopEdge": `_sStQ`,
	"plainHeader": `tOVmA`,
	"clickable": `MIc0p`,
	"separated": `me_pp`,
	"unified": `Hd2k4`,
	"selectedCard": `L8Jdd`,
	"revealHost": `Dxnn_`,
	"expandedContent": `v2RHh`,
	"sortIcon": `YwkxN`,
	"sortArrow": `hkRf3`,
	"sortArrowActive": `A8Ozh`,
	"skeletonRow": `Wsapx`,
	"dragHandle": `nvD6D`,
	"columnMenuTrigger": `zefcp`,
	"headerGrid": `foFMV`,
	"emptyState": `qVppG`,
	"columnsTriggerHost": `i9g7V`,
	"columnsTrigger": `Wk4jx`
};
export default ___CSS_LOADER_EXPORT___;
